import { Box, Stack, getStylesRef } from '@mantine/core';

import { SideBarItem } from './components/SideBarItem';
import { useShouldHideSideBar } from './hooks/useShouldHideSideBar';
import { useSideBarLinks } from './hooks/useSideBarLinks';

export const BID_RESPONSE_SIDEBAR_WIDTH = 68;

export function SideBar() {
  const links = useSideBarLinks();
  const shouldHideSideBar = useShouldHideSideBar();

  if (shouldHideSideBar) {
    return null;
  }

  return (
    <Box
      bg="white"
      w={BID_RESPONSE_SIDEBAR_WIDTH}
      h="100%"
      pos="relative"
      sx={{
        '&:hover': {
          [`& .${getStylesRef('expandedNav')}`]: {
            transform: 'translateX(0)',
          },
          [`& .${getStylesRef('compactNav')}`]: {
            transform: 'translateX(-100%)',
          },
        },
      }}
    >
      <Stack
        bg="white"
        px="02"
        py="01"
        spacing="02"
        w="100%"
        h="100%"
        sx={theme => ({
          borderRight: `1px solid ${theme.colors.gray[1]}`,
          ref: getStylesRef('compactNav'),
          transition: 'transform 0.3s ease-in-out',
        })}
      >
        {links.map(link => (
          <SideBarItem key={link.label} {...link} isCompact />
        ))}
      </Stack>
      <Stack
        w="284px"
        h="100%"
        bg="white"
        px="02"
        py="01"
        spacing="02"
        pos="absolute"
        top={0}
        left={0}
        sx={theme => ({
          transform: 'translateX(-100%)',
          zIndex: 1000,
          ref: getStylesRef('expandedNav'),
          borderRight: `1px solid ${theme.colors.gray[1]}`,
          transition: 'transform 0.3s ease-in-out',
        })}
      >
        {links.map(link => (
          <SideBarItem key={link.label} {...link} />
        ))}
      </Stack>
    </Box>
  );
}
